import ArrowIcon from 'assets/svg/arrow/arrow.svg'
import BurgerIcon from 'assets/svg/burger-icon/burger-icon.svg'
import GlobeIcon from 'assets/svg/globe/globe.svg'
import HelloRalaliIcon from 'assets/svg/hello-ralali/hello-ralali.svg'
import NewTooltipIcon from 'assets/svg/tooltip/new.svg'
import Category from 'common/components/Category'
import Popover from 'common/components/Popover'
import BusinessSolution from 'common/components/TopNav/BusinessSolution'
import Typography from 'common/components/Typography'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import { useFeatureFlags } from 'lib/feature-flags'
import styled from 'styled-components'

const Nav = styled.nav`
  background-color: ${theme.colors.white};
  border-top: 1px solid ${theme.colors.grayLight};
  border-bottom: 1px solid ${theme.colors.grayLight};
`

const Container = styled.div`
  height: 56px;
  width: ${theme.layout.containerWidth};
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const MenuMain = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  height: 18px;
  li {
    margin: 0 30px 0 0;
    position: relative;
    :nth-child(2) {
      border-left: 1px solid ${theme.colors.grayLight};
      padding-left: 30px;
    }
    :last-child {
      margin: 0;
    }
  }
`

const StyledLink = styled.a`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${theme.colors.black};
  &:hover,
  &:focus {
    color: ${theme.colors.orange};
    > p {
      color: ${theme.colors.orange};
    }
  }
  > p {
    text-transform: uppercase;
  }
`

const MenuAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 25px;
  > * {
    display: flex;
    padding: 0 15px;
    :last-child {
      padding-right: 0;
    }
  }
`

const SelectLanguageWrapper = styled.div`
  border-left: 1px solid ${theme.colors.grayLight};
`

const SelectLanguage = styled.span`
  height: 24px;
  color: ${theme.colors.black};
  display: flex;
  align-items: center;
`

const BottomArrowIcon = styled(ArrowIcon)`
  transform-origin: 50% 50%;
  transform: scale(0.8) rotate(180deg);
  margin-left: 2px;
  path {
    fill: currentColor;
  }
`

const WrapperTooltip = styled.span`
  position: absolute;
  top: -14px;
  right: ${({ hasPopover }) => (hasPopover ? '9px' : '-12px')};
`

function TopNav({
  onOpenOverlay,
  onCloseOverlay,
  show = true,
}: {
  onOpenOverlay?: Function
  onCloseOverlay?: Function
  show?: boolean
}): JSX.Element {
  const enableTokoLokal = useFeatureFlags(
    'biz--marketplace-enable-local-store--global',
  )
  if (!show) return <></>
  return (
    <Nav>
      <Container data-testid="topnav-container">
        <MenuMain>
          <li>
            <Popover
              side="bottom"
              position="full"
              onOpenOverlay={onOpenOverlay}
              onCloseOverlay={onCloseOverlay}
              full
              content={<Category />}
            >
              <StyledLink>
                <BurgerIcon />
                <Typography type="bparagraph" marginLeft="10px">
                  Kategori
                </Typography>
                <BottomArrowIcon />
              </StyledLink>
            </Popover>
          </li>

          <li>
            <StyledLink href={`${WEB_DESKTOP_RALALI_URL}/`}>
              <Typography type="bparagraph">Ralali.com</Typography>
            </StyledLink>
          </li>

          <li>
            <>
              <Popover
                side="bottom"
                position="customRight"
                onOpenOverlay={onOpenOverlay}
                onCloseOverlay={onCloseOverlay}
                full
                content={<BusinessSolution />}
              >
                <StyledLink data-testid="services-menu-test">
                  <Typography type="bparagraph">Layanan</Typography>
                  <BottomArrowIcon />
                </StyledLink>
              </Popover>
              <WrapperTooltip hasPopover>
                <NewTooltipIcon />
              </WrapperTooltip>
            </>
          </li>

          <li>
            <>
              <StyledLink
                href="https://news.ralali.com"
                target="_blank"
                rel="noreferrer"
              >
                <Typography type="bparagraph">Berita</Typography>
              </StyledLink>
            </>
          </li>

          {enableTokoLokal ? (
            <li>
              <>
                <StyledLink href="/local-store" passHref>
                  <Typography type="bparagraph">
                    TOKO LOKAL
                  </Typography>
                </StyledLink>
              </>
            </li>
          ) : (
            <></>
          )}
        </MenuMain>

        <MenuAction>
          <a href="/hubungikami">
            <HelloRalaliIcon />
          </a>
          <SelectLanguageWrapper>
            <SelectLanguage>
              <GlobeIcon />
              <Typography marginLeft="5px">ID</Typography>
              {/* <BottomArrowIcon /> */}
            </SelectLanguage>
          </SelectLanguageWrapper>
        </MenuAction>
      </Container>
    </Nav>
  )
}

export default TopNav
